import React from 'react';
import classNames from 'classnames';
import PageContext from '../../../pages/PageContext';
import { formatDateTime } from '../../../helpers/dateTimeHelpers';
import PropTypes from 'prop-types';
import DateTimeIcon from '../../../../icons/date-time.svg';
import defaultStyles from './StatusDate.module.scss';
import { NormalText } from '../../StyledComponents';

class StatusDate extends React.PureComponent {
  render() {
    const { date, full, styles: customStyles, color, fontSize, font, fontType, locale } = this.props;

    const styles = {
      ...defaultStyles,
      ...customStyles,
    };

    return (
      <PageContext.Consumer>
        {({ isMobile }) => (
          <div className={classNames(styles['status-date'], { [styles.mobile]: isMobile })}>
            <DateTimeIcon
              aria-hidden="true"
              className={classNames(styles.icon, styles['icon-base'])}
              style={{ fill: color }}
            />
            <span className={classNames(styles.date, styles['date-base'])}>
              <NormalText
                type={fontType || 'bodyPrimary'}
                isMobile={isMobile}
                fontSize={fontSize}
                font={font}
                color={color}
              >
                <time dateTime={new Date(date).toISOString()}>{formatDateTime(locale, new Date(date), full)}</time>
              </NormalText>
            </span>
          </div>
        )}
      </PageContext.Consumer>
    );
  }
}

StatusDate.propTypes = {
  fontSize: PropTypes.string,
  font: PropTypes.string,
  color: PropTypes.string,
  locale: PropTypes.string, // TODO: move to context
};

export default StatusDate;
